import React, { Component } from 'react'

import Header from '../components/Header'
import Footer from '../components/Footer'
import ClubDetail from '../components/ClubDetail'
import Products from '../components/Products'

const nl2br = require('react-nl2br')

class Club extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount () {
    }
    render() {
        return (
            <div>
                <Header/>
                <div className="content" id="saka-page">
                    <ClubDetail {...this.props}/>
                    <Products {...this.props}/>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Club